import { CSSResultGroup, html, css, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import componentStyles from './ghs-review-quote.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

import '../ghs-rate/ghs-rate';
import '../ghs-quote-testimonial/ghs-quote-testimonial';

/**
 * The ghs-review-quote component.
 * @element ghs-review-quote
 */
@customElement('ghs-review-quote')
export class GhsReviewQuote extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, css``];

  /**
   * Rating value.
   */
  @property({ type: Number }) rating = 0;

  /**
   * Review date.
   */
  @property({ type: String }) reviewDate: string;

  render(): TemplateResult {
    return html`
      <div class="review-quote">
        <ghs-quote-testimonial variant="plain" site=${this.site} full-width>
          <slot slot="quote-content" name="content"> </slot>
        </ghs-quote-testimonial>

        <div class="review-quote__footer">
          <div class="review-quote__date">${this.reviewDate}</div>
          <div class="review-quote__rating">
            <ghs-rate
              value=${this.rating}
              icon-size="22"
              icon-mobile-size="14"
              site=${this.site}
            ></ghs-rate>
          </div>
        </div>
      </div>
    `;
  }
}
